import React from 'react';
import { classNames } from '@geerd-nx/utils';
export interface INavigationButton {
  title: React.ReactNode;
  body: React.ReactNode;
  clickHandler: React.MouseEventHandler<HTMLDivElement>;
  alignment: 'left' | 'right';
}
export function NavigationButton({
  title,
  body,
  clickHandler,
  alignment,
}: INavigationButton) {
  return (
    <div
      onClick={clickHandler}
      className={classNames(
        alignment === 'right' ? 'items-end' : '',
        `cursor-pointer shadow-sm rounded-lg border px-4 py-2  flex hover:bg-gray-100 active:bg-gray-200 transition flex-col`,
      )}
    >
      <span className="text-gray-600 font-md">{title}</span>
      <span className="text-gray-900 font-bold">{body}</span>
    </div>
  );
}
